// IntegratedTmCalls.jsx — 통합 일일콜 메뉴(tm_call) 화면 (2026-10-13, 통합 계획 3단계 5번)
//   회사 2곳 이상 테넌트의 '일일콜현황 관리(통합)' 칸을 작업 대상 → 통합관리 안으로 옮긴 화면.
//   일일콜 등록 화면(CallRegister) 한 벌을 그대로 쓰고, 주소만 메뉴 주소(/api/admin/integrated-menus/{id}/tm-calls)로 바꾼다.
//   key={menuId}: 등록 화면은 처음 한 번만 읽으므로, 같은 주소에서 메뉴를 바꿔 열면 새로 그리게 한다.
import React from 'react';
import CallRegister from '../tm/CallRegister';

export default function IntegratedTmCalls({ menuId, companyCodes, pageTitle }) {
  const codes = Array.isArray(companyCodes)
    ? companyCodes.map((c) => String(c || '').trim().toUpperCase()).filter(Boolean)
    : [];
  return (
    <CallRegister
      key={menuId}
      adminMode
      integratedMenu={{ id: menuId, companyCodes: codes }}
      pageTitle={pageTitle || '일일콜현황 관리'}
    />
  );
}
